const testimonials = [
  {
    name: "James R.",
    location: "Palm Harbor, FL",
    rating: 5,
    text: "Our golf group had been planning a trip to St. Andrews for over a year. Two weeks before departure, I realized my passport had expired during the pandemic when I wasn't traveling. Fast Passport Center processed my renewal in five business days. I made the flight to Edinburgh, played the Old Course, and even had time for a round at Carnoustie. Their team understood exactly how important this trip was.",
    service: "Passport Renewal",
  },
  {
    name: "Linda K.",
    location: "Palm Harbor, FL",
    rating: 5,
    text: "We booked a Caribbean cruise from Port Tampa Bay for our anniversary. I checked our passports the week before sailing and discovered my husband's had expired six months ago. I panicked. Fast Passport Center got his renewal processed and back to us in four days. We made the cruise with time to spare. I can't thank them enough.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "David & Maria S.",
    location: "Palm Harbor, FL",
    rating: 5,
    text: "Our daughter was accepted into a summer exchange program in Barcelona with three weeks' notice. Her passport was issued when she was four and had expired. Fast Passport Center walked us through the child passport process, helped us gather the right documents, and processed everything in under a week. She made it to Spain and had the experience of a lifetime.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PalmHarborTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Palm Harbor Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Palm Harbor golf enthusiasts, cruise travelers, and families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}